module.exports = __webpack_public_path__ + "img/05.e7174cdf.jpg";